import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const ITEMS = [
  {
    quote:
      "A Áxis entregou uma plataforma que hoje sustenta decisões clínicas e administrativas do nosso dia a dia — precisão, agilidade e integração real com o Tasy.",
    author: "Dr. Paulo Safatle",
    role: "Diretor · Hospital São Nicolau",
    initials: "PS",
  },
  {
    quote:
      "Automatizamos rotinas que consumiam horas todos os dias. O time da Áxis é técnico, consultivo e entende de operação hospitalar de verdade.",
    author: "Michely Melo",
    role: "Coordenação · Hospital São Nicolau",
    initials: "MM",
  },
  {
    quote:
      "Os dashboards do Wely nos deram visibilidade em tempo real dos indicadores gerenciais. É outro nível de tomada de decisão.",
    author: "Angelo",
    role: "Gestão · Hospital São Nicolau",
    initials: "AN",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="bg-[#F9FAFB] py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-16 max-w-3xl"
        >
          <p className="font-mono-axis text-xs uppercase tracking-widest text-[#3B82F6] mb-4">
            /06 · Depoimentos
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tighter font-semibold text-[#111827] leading-[1.05]">
            O que dizem quem nos{" "}
            <span className="text-[#1E3A8A]">confiou</span> sua operação.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {ITEMS.map((t, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{
                duration: 0.7,
                delay: 0.1 * i,
                ease: [0.22, 1, 0.36, 1],
              }}
              whileHover={{ y: -6 }}
              className="relative bg-white border border-gray-200 p-8 lg:p-10 transition-shadow duration-300 hover:shadow-md"
            >
              <Quote className="w-8 h-8 text-[#1E3A8A] mb-6" strokeWidth={1.5} />
              <blockquote className="font-display text-lg lg:text-xl leading-snug text-[#111827] tracking-tight">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-gray-200 flex items-center gap-3">
                <span className="w-10 h-10 rounded-full bg-gradient-to-br from-[#3B82F6] to-[#1E3A8A] text-white flex items-center justify-center font-display text-sm font-semibold">
                  {t.initials}
                </span>
                <div>
                  <p className="text-sm font-medium text-[#111827]">
                    {t.author}
                  </p>
                  <p className="text-xs text-gray-500 mt-0.5 font-mono-axis uppercase tracking-widest">
                    {t.role}
                  </p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
